import React from "react";
import { DealFileListClient } from "~/components/common/deals/show/files/DealFileListClient";
import { DealFileListVendor } from "~/components/common/deals/show/files/DealFileListVendor";
import { DealMainSpLinksClient } from "~/components/common/deals/show/main/DealMainSpLinksClient";
import { DealMainSpLinksVendor } from "~/components/common/deals/show/main/DealMainSpLinksVendor";
import { DealMainWorkflowClient } from "~/components/common/deals/show/main/DealMainWorkflowClient";
import { DealMainWorkflowVendor } from "~/components/common/deals/show/main/DealMainWorkflowVendor";
import { DealTabs } from "~/components/common/deals/show/main/DealTabs";
import { DealHistoryClientList } from "~/components/common/deals/show/main/histories/DealHistoryClientList";
import { DealHistoryVendorList } from "~/components/common/deals/show/main/histories/DealHistoryVendorList";
import { CompletionReportImageClientPanel } from "~/components/specifics/deals/parts/CompletionReportImageClientPanel";
import { CompletionReportImageVendorPanel } from "~/components/specifics/deals/parts/CompletionReportImageVendorPanel";
import { EstimationClientPanel } from "~/components/specifics/deals/parts/EstimationClientPanel";
import { EstimationVendorPanel } from "~/components/specifics/deals/parts/EstimationVendorPanel";
import { InspectionReportImageClientPanel } from "~/components/specifics/deals/parts/InspectionReportImageClientPanel";
import { InspectionReportImageVendorPanel } from "~/components/specifics/deals/parts/InspectionReportImageVendorPanel";
import type { Deal } from "~/models/Deal";
import { matchDealType } from "~/models/Deal";
import { IN_CONSTRUCTION } from "~/models/Status";
import Styles from "./DealMain.module.scss";

type Props = {
	deal: Deal;
	isAdmin: boolean;
	isVendor: boolean;
};

export type TabType =
	| "workflow"
	| "reports"
	| "estimation"
	| "histories"
	| "files";

export const DealMain: React.FC<Props> = ({
	deal,
	isVendor,
	isAdmin
}: Props) => {
	const [tabType, setTabType] = React.useState<TabType>("workflow");
	const showCompleteImagePanel =
		deal.statusId >= IN_CONSTRUCTION || matchDealType(deal, "repair");
	const handleChangeTab = React.useCallback((newTabType: TabType): void => {
		setTabType(newTabType);
	}, []);
	return (
		<div className={Styles.DealMain}>
			{isVendor ? (
				<DealMainSpLinksVendor isAdmin={isAdmin} />
			) : (
				<DealMainSpLinksClient isAdmin={isAdmin} />
			)}
			<DealTabs
				deal={deal}
				handleChangeTab={handleChangeTab}
				tabType={tabType}
			/>
			<div className={tabType === "workflow" ? Styles.Show : Styles.Hide}>
				{isVendor ? <DealMainWorkflowVendor /> : <DealMainWorkflowClient />}
			</div>
			<div className={tabType === "reports" ? Styles.Show : Styles.Hide}>
				{isVendor ? (
					<div className={Styles.Card}>
						<InspectionReportImageVendorPanel />
						{showCompleteImagePanel ? (
							<CompletionReportImageVendorPanel />
						) : null}
					</div>
				) : (
					<div className={Styles.Card}>
						<InspectionReportImageClientPanel />
						{showCompleteImagePanel ? (
							<CompletionReportImageClientPanel />
						) : null}
					</div>
				)}
			</div>
			{tabType === "histories" && (
				// NOTE: mutateを実行するためにタブを開く度にrenderingし直す
				<div className={Styles.Show}>
					<div className={Styles.Card}>
						{isVendor ? (
							<DealHistoryVendorList dealId={deal.id} />
						) : (
							<DealHistoryClientList dealId={deal.id} />
						)}
					</div>
				</div>
			)}
			<div className={tabType === "estimation" ? Styles.Show : Styles.Hide}>
				<div className={Styles.Card}>
					{isVendor ? (
						<EstimationVendorPanel deal={deal} />
					) : (
						<EstimationClientPanel deal={deal} />
					)}
				</div>
			</div>
			<div className={tabType === "files" ? Styles.Show : Styles.Hide}>
				{isVendor ? <DealFileListVendor /> : <DealFileListClient />}
			</div>
		</div>
	);
};
